export default __webpack_public_path__ + "static/media/gallery - story - babbitty (1)_01.a611bc16.jpg";